import './../../../bankrate-tracking/ratetable'
import './../../bankrate-ga-dataLayer/custom-events/ecommerce-cpc'

import eventHub from './../../bankrate-events'
import meta from './../../../bankrate-tracking/meta'

let prepSortName = function(sortName, isAscending) {
  if (sortName === 'sort.default') {
    return 'default'
  } else {
    return (
      (sortName &&
        typeof sortName === 'string' &&
        sortName.toLowerCase().replace('sort.', '') +
          ' ' +
          (isAscending && isAscending === true
            ? 'ascending'
            : 'descending' || '')) ||
      'default'
    ).replace(/ /g, '-')
  }
}

eventHub.$on('findARate::change', () => {
  dataLayer = window.dataLayer || []
  dataLayer.push({ event: 'findARateChange' })
})

eventHub.$on('autoCalc::showAmortization', () => {
  dataLayer = window.dataLayer || []
  dataLayer.push({ event: 'showAmortizationSchedule' })
})

eventHub.$on('autoCalc::setLocation', location => {
  dataLayer = window.dataLayer || []
  let splitLocation = location.split(',')
  dataLayer.push({
    'user.city': splitLocation[0],
    'user.state': splitLocation[1].trim()
  })
})

eventHub.$on('autoCalc::setLoanAmount', amount => {
  dataLayer = window.dataLayer || []
  dataLayer.push({ amount: amount })
})

eventHub.$on('autoCalc::setLoanType', type => {
  dataLayer = window.dataLayer || []
  dataLayer.push({ product_type: 'Purchase' })
  dataLayer.push({ purchase_type: type })
})

eventHub.$on('autoCalc::setTerm', term => {
  dataLayer = window.dataLayer || []
  dataLayer.push({ term: term })
})

eventHub.$on('ratetableUpdated.ratesLoaded', params => {
  dataLayer.push({
    editorial_listings: meta.countEditorialListings(),
    paid_listings: meta.countPaidListings()
  })
  meta.setMetaData('SortBy', prepSortName(params.sort, params.isAscending))
  meta.buildRateImpression()
})

eventHub.$on('ratetableUpdated.sorted', (sortValue, isAscending) => {
  meta.setMetaData('SortBy', prepSortName(sortValue, isAscending))
  meta.setEvents('event118')

  dataLayer = window.dataLayer || []
  dataLayer.push({
    event: 'ratetableUpdated.sorted',
    sortby: prepSortName(sortValue, isAscending)
  })
})

eventHub.$on('rateTable.offerDetails', function() {
  dataLayer = window.dataLayer || []
  dataLayer.push({
    event: 'ratetable.offerdetail'
  })
})

eventHub.$on('ratetableError', () => {
  meta.buildRateImpression()
})
